import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import dayjs from "dayjs";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./WeeklyCalendar.css";
import { Modal } from "antd";
import CalendarPopup from "./CalendarPopup";
import ReleaseRoomPopup from "./ReleaseRoomPopup";
import { CustomToolbar } from "./CustomToolbar";

const localizer = momentLocalizer(moment);

export const WeeklyCalendar = ({
  selectedMeetingRoom,
  selectedPlace,
  events,
  selectSlot,
  startDate,
  endDate,
  startTime,
  endTime,
  selectedSlot,
  dateRange,
  setDateRange,
}) => {
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [calendarPopupData, setCalendarPopupData] = useState(null);
  const [displayEvents, setDisplayEvents] = useState(null);
  const [releaseModal, setReleaseModal] = useState(null);
  const [bookedSlot, setBookedSlot] = useState(null);

  const handleSelectEvent = (event) => {
    if (event?.isFilteredEvent) setBookedSlot(event);
  };

  const showModal = (key) => {
    setCalendarPopupData(key);
    setIsModalOpen(true);
  };
  const handlePopupCancel = () => {
    setCalendarPopupData(null);
    setIsModalOpen(false);
  };

  const openRelease = (data) => {
    setReleaseModal(data);
    handlePopupCancel();
  };

  const handleReleaseSuccess = () => {
    setReleaseModal(null);
  };

  const updateFilteredEvents = useCallback(() => {
    //if (selectedMeetingRoom) {
      const today = dayjs().startOf('day');
      const filtered = events.filter((event)=> dayjs(event.start) > today)
        .map((event) => ({ ...event, isFilteredEvent: true }));
      setFilteredEvents(filtered);
    // } else {
    //   setFilteredEvents([]);
    // }
  }, [events, dateRange]);

  useEffect(() => {
    updateFilteredEvents();
  }, [selectedMeetingRoom, events, dateRange, updateFilteredEvents]);

  const eventPropGetter = useCallback(
   
    (meet) => ({
      ...(!meet. isFilteredEvent  && {
        style: {
          backgroundColor: "#A888B5",
          color: "#000000",
        },
      }),
      ...(meet.isFilteredEvent && {
          style: {
            backgroundColor: "#90EE90",
            color: "#000000",
          },
        })
    }),
    []
  );

  // const handleSelectEvent = (event) => {
  //   if (event.isFilteredEvent) {
  //     showModal(event);
  //   }
  // };

  useEffect(() => {
    setDisplayEvents(selectedSlot);
  }, [selectedSlot]);

  const addEvent = (start, end) => {
    const newEvent = {
      start: start.toDate(),
      end: end.toDate(),
      isFilteredEvent: false,
    };

    setDisplayEvents(newEvent);
  };

  useEffect(() => {
    const startDateTime = dayjs(
      `${startDate.format("YYYY-MM-DD")}T${startTime.format("HH:mm")}`
    );
    const endDateTime = dayjs(
      `${startDate.format("YYYY-MM-DD")}T${endTime.format("HH:mm")}`
    );

    if (startDateTime.isValid() && endDateTime.isValid()) {
      addEvent(startDateTime, endDateTime);
    }
  }, [startDate, endDate, startTime, endTime]);

  const handleNavigate = (date) => {
    setDateRange({
      start: moment(date).startOf("week").toDate(),
      end: moment(date).endOf("week").toDate(),
    });
  };

  return (
    <div className="week-view-container" style={{ height: "89vh", width: "100%", marginLeft: "1rem" }}>
      <Calendar
        localizer={localizer}
        events={[...filteredEvents, displayEvents]}
        defaultView="week"
        views={["week"]}
        style={{ flex: 1, border: "1px solid #ddd", borderRadius: "5px" }}
        eventPropGetter={eventPropGetter}
        selectable
        onSelectSlot={(selectedSlot) => selectSlot(selectedSlot)}
        onSelectEvent={handleSelectEvent}
        onNavigate={handleNavigate}
        min={moment().startOf("day").toDate()}
        max={moment().endOf("day").toDate()}
        scrollToTime={moment().startOf("day").hour(9).toDate()}
        popup
        startAccessor="start"
        endAccessor="end"
        components={{
          toolbar: CustomToolbar,
        }}
      />
      <Modal
        open={isModalOpen && calendarPopupData != null}
        onCancel={handlePopupCancel}
        footer={null}
        style={{ width: "100px", position: "fixed", top: "0px", left: "35%" }}
      >
        <CalendarPopup
          event={calendarPopupData}
          handlePopupCancel={handlePopupCancel}
          onOpenRelease={openRelease}
        />
      </Modal>
      <Modal
        open={!!bookedSlot}
        title="Booking details"
        onCancel={() => setBookedSlot(null)}
        footer={null}
        width={320}
        centered
      >
        {bookedSlot && (
          <>
            <p style={{ margin: "8px 0 4px" }}>
              <strong>Booked by:</strong> {bookedSlot.bookedBy || "-"}
            </p>
            <p style={{ margin: 0 }}>
              <strong>Time:</strong> {dayjs(bookedSlot.start).format("HH:mm")} –{" "}
              {dayjs(bookedSlot.end).format("HH:mm")}
            </p>
          </>
        )}
      </Modal>
      <ReleaseRoomPopup
        open={!!releaseModal}
        modalData={releaseModal}
        onCancel={() => setReleaseModal(null)}
        onSuccess={handleReleaseSuccess}
      />
    </div>
  );
};
